__turbopack_context__.v({
  "alertYellow": "dUJmIa_alertYellow",
  "black": "dUJmIa_black",
  "black90": "dUJmIa_black90",
  "content": "dUJmIa_content",
  "cross": "dUJmIa_cross",
  "cyan": "dUJmIa_cyan",
  "darkStone": "dUJmIa_darkStone",
  "dismissibleModal": "dUJmIa_dismissibleModal",
  "dismissiblePopover": "dUJmIa_dismissiblePopover",
  "fuschiaPunch": "dUJmIa_fuschiaPunch",
  "image": "dUJmIa_image",
  "limeSorbet": "dUJmIa_limeSorbet",
  "olive100": "dUJmIa_olive100",
  "olive20": "dUJmIa_olive20",
  "softBlack": "dUJmIa_softBlack",
  "teal100": "dUJmIa_teal100",
  "teal20": "dUJmIa_teal20",
  "text": "dUJmIa_text",
  "tick": "dUJmIa_tick",
  "title": "dUJmIa_title",
  "warmStone": "dUJmIa_warmStone",
  "white": "dUJmIa_white",
});
